import { Button, Flex, Text } from 'rebass';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import theme from '../../../styles/theme';
import { LogoSvg } from './Logo';
import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { isMobile } from 'react-device-detect';

const data = [
  {
    name: '',
    uv: 1200,
  },
  {
    name: '1 mo',
    uv: 1000,
  },
  {
    name: '6 mo',
    uv: 400,
  },
  {
    name: '12 mo',
    uv: 200,
  },
  {
    name: '',
    uv: 150,
  },
];

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;

const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

export const GoalReassurance = ({ onContinue, state }) => {
  return (
    <Flex flexDirection={'column'} flex={1}>
      <LogoSvg />
      <Flex style={{ background: theme.color.darkBlue, borderRadius: 40, height: 'calc(100vh / 2)', paddingBottom: '24px' }} mt={isMobile?3:4} flexDirection={'column'}>
        <Text style={{ color: 'white', fontSize: isMobile ? '28px' : '36px', fontWeight: 400, marginLeft: '20px', marginRight: '20px', marginBottom: '16px', marginTop: '24px' }}>
          Lose up to 20% of your weight
        </Text>
        <Text style={{ color: 'white', fontSize: isMobile ? '14px' : '16px', marginBottom: '16px', marginLeft: '20px', marginRight: '20px' }}>
          On average, people lost 15–20% of their body weight in a 68-week clinical trial study of Wegovy®*
        </Text>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            width={500}
            height={400}
            data={data}
            margin={{
              top: 10,
              right: -80,
              left: -80,
              bottom: 0,
            }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="15%" stopColor="white" stopOpacity={0.6} />
                <stop offset="95%" stopColor="white" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="name" stroke="#a8a29b" />
            <Tooltip />
            <Area type="monotone" dataKey="uv" stroke="#fac66f" fill="url(#colorUv)" dot={{ stroke: '#fac66f', strokeWidth: 2, fill: '#fac66f', width: 8, height: 8 }} strokeWidth={4} />
          </AreaChart>
        </ResponsiveContainer>
      </Flex>

      <FootNote mb={4} mt={3}>
        <Text style={{ color: 'rgba(0, 0, 0, 0.33)', fontSize: '12px' }} mb={3}>
          Graph for illustrative purposes only to demonstrate potential appetite suppression trends. Individual results will vary. *Along with a reduced calorie diet and increased exercise. In a
          68-week clinical study of Wegovy®, about 1 in 3 adults with obesity or with overweight and weight-related medical problems achieved 20% weight loss. Average weight loss achieved was 15%.
          Wegovy®is a registered trademark of Novo Nordisk A/S.
        </Text>
        <Flex alignItems={isMobile ? 'stretch' : 'flex-end'} justifyContent={isMobile ? 'stretch' : 'flex-end'} mb={6}>
          <Button variant={'primary'} onClick={onContinue} flex={isMobile ? 1 : ''}>
            Next
          </Button>
        </Flex>
      </FootNote>
    </Flex>
  );
};
